import React from 'react';
import { FlatList, Image } from 'react-native';
import type { FundOwnershipProps, PublicPlayerProps } from "../../types"
import moment from 'moment-mini';
import { Text, View } from '../../Components/Themed';

type FundOwnershipListProps = {
    fund_ownerships:FundOwnershipProps[],
    players:PublicPlayerProps[]
}
const FundOwnershipList = ({ fund_ownerships, players }:FundOwnershipListProps) => {

    const renderFundOwnerships = (data:{ item:FundOwnershipProps, index:number }) => {
        const player = players.find(p => p.player_id == data.item.player_id);
        if(!player){ return <></> }
        return (
            <View style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <Image
                    source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:30, width:30, borderRadius:100 }}
                    resizeMode='cover'
                />
                <View style={{ flex:1, marginLeft:10 }}>
                    <Text size={14} theme='h1' weight='bold'>{player.first_name} {player.last_name}</Text>
                    <Text style={{ marginTop:3 }} size={12} weight='regular' theme='description'>Owner since {moment(data.item.create_datetime).format('MMM DD YYYY')}</Text>
                </View>
                <Text size={14} weight='bold' theme='h1'>{(data.item.ownership_pct * 100).toFixed(2)}%</Text>
            </View>
        )
    }

    return (
        <View>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>Fund Owners</Text>
                    <Text style={{ marginTop:3 }} theme='description'>Below are the players that have invested in this fund sorted by their ownership pct.</Text>
                </View>
            </View>
            <View transparent style={{ padding:0 }}>
                <FlatList
                    key={'fund_ownerships'}
                    data={fund_ownerships.sort((a,b) => b.ownership_pct - a.ownership_pct)}
                    keyExtractor={(item) => item.fund_ownership_id.toString()}
                    renderItem={renderFundOwnerships}
                />
            </View>
        </View>
    )
}

export default FundOwnershipList